import { SensorData } from 'Simulations/SensorPoint';
import { OctTree } from '@data/OctTree';

export const CONTEXT_KEYS = {
    AVERAGE: Symbol('average'),
    UNOBSTRUCTED_FREEFACES: Symbol('unobstructedFaces'),
} as const;

export type StageContext = {
    sensors: SensorData[];
    data: Map<symbol, any>;
    absoluteMinMax: [number, number]; // This is incoming from the layer and is the global min/max accross all frames
    remappedMinMax: [number, number]; // By default this is the  min/max on the layer.  But can mutate accross the local sensors domain
    octTree: OctTree;
};

// Usage
export class ContextHelper {
    static set<T>(context: StageContext, key: symbol, value: T): void {
        context.data.set(key, value);
    }

    static get<T>(context: StageContext, key: symbol): T {
        if (!context.data.has(key)) {
            throw new Error(`Context missing required field: ${key.toString()}`);
        }
        return context.data.get(key) as T;
    }

    static create(
        sensors: SensorData[],
        absoluteMinMax: [number, number],
        remappedMinMax: [number, number],
        octTree: OctTree
    ): StageContext {
        return {
            sensors,
            data: new Map(),
            absoluteMinMax,
            remappedMinMax,
            octTree,
        };
    }
}
